
import { Button } from "@/components/ui/button";
import { AuthTabs } from "./AuthTabs";
import { ForgotPasswordForm } from "./ForgotPasswordForm";
import { ResetPasswordForm } from "./ResetPasswordForm";

interface AuthContentProps {
  mode: "signin" | "signup" | "forgotPassword" | "resetPassword";
  onTabChange: (value: string) => void;
  onForgotPassword: () => void;
  onBackToSignIn: () => void;
}

export function AuthContent({ mode, onTabChange, onForgotPassword, onBackToSignIn }: AuthContentProps) {
  if (mode === "forgotPassword") {
    return (
      <div>
        <ForgotPasswordForm onBackToSignIn={onBackToSignIn} />
      </div>
    );
  }
  
  if (mode === "resetPassword") {
    return (
      <div>
        <ResetPasswordForm />
        <div className="mt-4 text-center">
          <Button variant="link" onClick={onBackToSignIn}>
            Back to sign in
          </Button>
        </div>
      </div>
    );
  }
  
  return (
    <AuthTabs 
      activeTab={mode} 
      onTabChange={onTabChange} 
      onForgotPassword={onForgotPassword} 
    />
  );
}
